(function () {
  var ELLIPSIS = '...';
  var RESIZE_DELAY_MS = 150;
  var resizeTimer;

  function debouncedRun() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(truncateArtworkMeta, RESIZE_DELAY_MS);
  }

  function fitsWithinLines(meta, maxLines) {
    var lineHeight = parseFloat(getComputedStyle(meta).lineHeight);
    if (!lineHeight || Number.isNaN(lineHeight)) {
      return true;
    }
    return meta.scrollHeight <= lineHeight * maxLines + 1;
  }

  function truncateArtworkMeta() {
    document.querySelectorAll('[data-artwork-meta-lines]').forEach(function (meta) {
      var medium = meta.querySelector('.artwork-meta__value--medium');
      if (!medium) {
        return;
      }

      var maxLines = parseInt(meta.getAttribute('data-artwork-meta-lines'), 10) || 2;
      var full = medium.getAttribute('data-artwork-meta-medium-full');

      if (!full) {
        full = medium.textContent.trim();
        medium.setAttribute('data-artwork-meta-medium-full', full);
      }

      medium.textContent = full;

      if (!full || fitsWithinLines(meta, maxLines)) {
        return;
      }

      var low = 0;
      var high = full.length;
      var best = 0;

      while (low <= high) {
        var mid = Math.floor((low + high) / 2);
        var slice = full.slice(0, mid).trimEnd();
        medium.textContent = mid < full.length ? slice + ELLIPSIS : full;

        if (fitsWithinLines(meta, maxLines)) {
          best = mid;
          low = mid + 1;
        } else {
          high = mid - 1;
        }
      }

      if (best < full.length) {
        medium.textContent = full.slice(0, best).trimEnd() + ELLIPSIS;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', truncateArtworkMeta);
  } else {
    truncateArtworkMeta();
  }

  window.addEventListener('resize', debouncedRun);
  document.addEventListener('shopify:section:load', truncateArtworkMeta);
})();
